module.exports = function anonymous(it
/**/) {
var out='<div class="plot-wrapper last-parameters span7 offset1"> <div class="row-fluid"> <h2 class="title">Idler coupling efficiency assuming symmetric coupling </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-modesolver">&#x2296;</button> </div> </div><div class="signalmode"> <!-- heat map goes here --></div></div>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/dot-loader!./browser/library/js/templates/couplingefficiency-layout.tpl
 ** module id = 506
 ** module chunks = 1
 **/